import {ReactNode} from 'react';
import {Button} from '@tickchak/react-share/app';
import TimetableToolbar from '../timetableToolbar/TimetableToolbar';
import SearchFilterBar from '../../../../component/searchFilterBar/SearchFilterBar';
import * as css from './TimetableHeader.css';

type Props = {
    conferenceDatesAction: {label: string; onClick: () => void; icon?: ReactNode};
    searchQuery: string;
    onSearchChange: (value: string) => void;
};

const TimetableHeader = ({conferenceDatesAction, searchQuery, onSearchChange}: Props) => {
    return (
        <css.wrap>
            <css.contentArea>
                <css.toolbarRow>
                    <TimetableToolbar />
                    <Button
                        variant="neutral"
                        size="category"
                        onClick={conferenceDatesAction.onClick}
                    >
                        {conferenceDatesAction.label}
                    </Button>
                </css.toolbarRow>
                <SearchFilterBar search={searchQuery} onSearch={onSearchChange} filterDisabled dataCy="timetable" />
            </css.contentArea>
        </css.wrap>
    );
};

export default TimetableHeader;
